import { connect } from 'react-redux'
import './MainContent.scss'

const MainContent = (props) => {
    const componentClass = 'smart-modals-main-content'

    return (
        <div className={componentClass}>
            <div className={`${componentClass}__body`}>{props.children}</div>
            {!props.hideFooter && (
                <div className={`${componentClass}__footer`}>
                    {props.footer}
                </div>
            )}
        </div>
    )
}

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(MainContent)
